module.exports = "Interna"